__turbopack_context__.v({
  "container": "TextInput-module-scss-module__4lxTLa__container",
  "icon": "TextInput-module-scss-module__4lxTLa__icon",
  "input": "TextInput-module-scss-module__4lxTLa__input",
});
